import { render, staticRenderFns } from "./WrestlingNewsSlider.vue?vue&type=template&id=0000b2f0&scoped=true"
import script from "./WrestlingNewsSlider.vue?vue&type=script&lang=js"
export * from "./WrestlingNewsSlider.vue?vue&type=script&lang=js"
import style0 from "./WrestlingNewsSlider.vue?vue&type=style&index=0&id=0000b2f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0000b2f0",
  null
  
)

export default component.exports